module.exports = __webpack_public_path__ + "img/selected2-min.acb768ec.png";